// Shared by the cart popup, full cart page, and product page's dynamic
// checkout button. Keeps a customer from ever reaching /checkout with a
// cart below the shipping-efficient minimum — the checkout Function still
// enforces this too, but by the time a customer sees THAT message they've
// already generated an abandoned checkout record. Gating the button here
// stops that from happening for the common case (a normal click through
// the storefront), while the Function remains the backend safety net for
// anything that reaches checkout by another path.
//
// The four exact thresholds mirror extensions/checkout-rules-validation/src/cart_validations_generate_run.js
// exactly (MIN_SUBTOTAL_BY_CURRENCY) — keep the two in sync if either changes.
//
// Cart totals are read from #cart-icon-bubble's own hidden JSON tag
// (sections/cart-icon-bubble.liquid), never from a separate /cart.js
// fetch. That section is rendered fresh, server-side, on every page load
// AND is part of the "sections" payload every add/change mutation already
// returns and writes into the DOM — so reading it here is reading data
// Shopify just handed over in that same response, not a second, later
// read that can come back stale.
window.MinimumOrderGate = (function () {
  var MIN_SUBTOTAL_BY_CURRENCY = { CAD: 6.25, USD: 5.25, AUD: 7.25, GBP: 4.25 };

  // Approximate whole-number thresholds for every other currency this
  // store has enabled (Shop.enabledPresentmentCurrencies, 93 total as of
  // 2026-09-10). Derived directly from this store's own real Shopify
  // pricing — not a generic exchange-rate guess: pulled via
  // productVariant.contextualPricing for a real $4.50 CAD product across
  // every enabled market, scaled to the 6.25 CAD threshold used for the
  // fallback markets, then rounded UP to a whole number — same rounding
  // rule as every other non-cent currency here, so the number shown is
  // never lower than what's enforced. These are a snapshot of Shopify's
  // currency conversion at the time they were derived, not a live rate —
  // if exchange rates drift significantly, rerun the same
  // contextualPricing lookup and refresh this table.
  var APPROX_MIN_SUBTOTAL_BY_CURRENCY = {
    AED: 20, AFN: 417, AMD: 1945, ANG: 10, AWG: 10, AZN: 10, BAM: 10, BBD: 12,
    BDT: 695, BIF: 15278, BSD: 6, BWP: 69, BZD: 12, CDF: 12500, CHF: 5,
    CRC: 2362, CVE: 556, CZK: 105, DJF: 973, DKK: 34, DOP: 417, EGP: 257,
    ETB: 805, EUR: 6, FJD: 12, GMD: 363, GNF: 44445, GTQ: 39, GYD: 1112,
    HNL: 135, HUF: 1667, IDR: 87500, ILS: 16, ISK: 695, JMD: 834, JPY: 834,
    KES: 695, KGS: 556, KHR: 20834, KYD: 5, KZT: 2362, LBP: 445834, LKR: 1667,
    MAD: 48, MDL: 87, MKD: 278, MMK: 19445, MNT: 18056, MOP: 41, MUR: 234,
    MVR: 78, MWK: 8750, MYR: 21, NGN: 7084, NIO: 184, NPR: 834, NZD: 10,
    PEN: 19, PGK: 24, PHP: 417, PKR: 1389, PLN: 20, QAR: 20, RON: 24,
    RSD: 556, RWF: 7362, SAR: 20, SBD: 41, SEK: 49, SHP: 5, SLL: 113889,
    STD: 105556, THB: 166, TJS: 48, TOP: 13, TTD: 35, TWD: 159, TZS: 13889,
    UAH: 223, UGX: 19445, UYU: 202, UZS: 59723, VND: 129167, VUV: 695,
    WST: 14, XAF: 2917, XCD: 14, XOF: 2917, XPF: 556
  };

  // Last-resort fallback if Shopify ever enables a currency not in either
  // map above (none exist today — every one of this shop's 93 enabled
  // presentment currencies is listed). Matches the backend Function's own
  // CAD-fallback number so behaviour stays conservative rather than ever
  // silently unlocking.
  var MIN_SUBTOTAL_CAD_FALLBACK = 6.25;

  var CURRENCIES_WITH_CENTS = ['CAD', 'USD'];
  var CURRENCY_SYMBOLS = { CAD: '$', USD: '$', AUD: '$', NZD: '$', GBP: '£', EUR: '€', JPY: '¥', ILS: '₪' };

  function belowMinimum(cart) {
    var threshold = MIN_SUBTOTAL_BY_CURRENCY[cart.currency];
    if (threshold === undefined) threshold = APPROX_MIN_SUBTOTAL_BY_CURRENCY[cart.currency];
    if (threshold === undefined) threshold = MIN_SUBTOTAL_CAD_FALLBACK;
    return cart.subtotal / 100 <= threshold ? threshold : false;
  }

  function messageFor(threshold, currency) {
    var symbol = CURRENCY_SYMBOLS[currency] || '';
    var amount = CURRENCIES_WITH_CENTS.indexOf(currency) !== -1
      ? threshold.toFixed(2)
      : Math.ceil(threshold).toString();
    return 'To make the most of your shipping cost, we have a ' + symbol + amount + ' ' +
      currency + ' minimum per order. Add another item to keep going!';
  }

  function readCurrentCart() {
    var el = document.getElementById('cart-icon-bubble-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  return { belowMinimum: belowMinimum, messageFor: messageFor, readCurrentCart: readCurrentCart };
})();
